import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import TopBar from './components/TopBar';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import TeamPage from './pages/Team';
import ServicesPage from './pages/ServicesPage';
import ServiceDetailPage from './pages/ServiceDetail';
import ContactPage from './pages/Contact';
import Query from './pages/Query';
import Careers from './pages/Careers';
import AdminBlog from './pages/AdminBlog';
import Blogs from './pages/Blogs';
import BlogDetail from './pages/BlogDetail';

// Knowledge Bank imports
import KnowledgeBank from './pages/knowledge/KnowledgeBank';
import Calculators from './pages/knowledge/Calculators';
import Bulletins from './pages/knowledge/Bulletins';
import Utilities from './pages/knowledge/Utilities';
import Links from './pages/knowledge/Links';
import Acts from './pages/knowledge/Acts';
import Rules from './pages/knowledge/Rules';
import Forms from './pages/knowledge/Forms';

function AppLayout() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin-blog');

  return (
    <>
      <ScrollToTop />
      {!isAdmin && <TopBar />}
      {!isAdmin && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/team" element={<TeamPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/services/:slug" element={<ServiceDetailPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/query" element={<Query />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/admin-blog" element={<AdminBlog />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blogs/:id" element={<BlogDetail />} />
        
        {/* Knowledge Bank routes */}
        <Route path="/knowledge" element={<KnowledgeBank />} />
        <Route path="/knowledge/calculators" element={<Calculators />} />
        <Route path="/knowledge/bulletins" element={<Bulletins />} />
        <Route path="/knowledge/utilities" element={<Utilities />} />
        <Route path="/knowledge/links" element={<Links />} />
        <Route path="/knowledge/acts" element={<Acts />} />
        <Route path="/knowledge/rules" element={<Rules />} />
        <Route path="/knowledge/forms" element={<Forms />} />
      </Routes>
      {!isAdmin && <Footer />}
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppLayout />
    </BrowserRouter>
  );
}

export default App;

